import { service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';

interface SearchPageTotalComponentArgs {
  total: number;
}

export default class SearchPageTotalComponent extends Component<SearchPageTotalComponentArgs> {
  @service declare intl: IntlService;
  constructor(owner: unknown, args: SearchPageTotalComponentArgs) {
    super(owner, args);
  }
  get singularOrPluralizeName() {
    return this.args.total > 1
      ? this.intl.t('components.search-page.filters.formations')
      : this.intl.t('components.search-page.filters.formation');
  }
}
